import React from 'react'
import { SvgTick } from '../assets/images'
import { StepperProps } from '../utils'

const StepperBV: React.FC<StepperProps> = ({
  steps,
  currentStep,
  fontSize = 'text-xs',
}) => {
  return (
    <div className="flex items-center space-x-2 justify-center">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep
        const isActive = index === currentStep
        let stepColor: 'green' | 'blue' | 'grey'
        if (isCompleted) {
          stepColor = 'green'
        } else if (isActive) {
          stepColor = 'blue'
        } else {
          stepColor = 'grey'
        }

        const backgroundClasses = {
          blue: 'bg-[#0A6FCD]',
          green: 'bg-[#4E8842]',
          grey: 'bg-[#5E5E5E]',
        }
        const borderClasses = {
          blue: 'border-[#0A6FCD]',
          green: 'border-[#4E8842]',
          grey: 'border-[#5E5E5E]',
        }
        const fontClasses = {
          blue: 'text-black',
          green: 'text-black',
          grey: 'text-[#5E5E5E]',
        }

        return (
          <div key={`${step.label}-${index}`} className="flex items-center">
            <div
              className={`flex items-center align-middle justify-center w-8 h-8 rounded-full bg-white border  ${borderClasses?.[stepColor]}`}
            >
              <div
                className={`flex items-center justify-center w-6 h-6 text-white rounded-full ${backgroundClasses?.[stepColor]}`}
              >
                {isCompleted ? <SvgTick /> : index + 1}
              </div>
            </div>

            <span
              className={`pl-1 ${fontSize} font-primary text-nowrap ${fontClasses?.[stepColor]}`}
            >
              {step.label}
            </span>

            {index < steps.length - 1 && (
              <div
                className={`w-5 h-0.5 ${backgroundClasses?.[stepColor]} ml-2`}
              ></div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default StepperBV
